"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListView_1 = require("../ListView");
var RowLayout = /** @class */ (function () {
    /**
     * @param spacing Spacing between items
     * @param padding Padding between container and image itself (box model)
     */
    function RowLayout(spacing, padding) {
        if (spacing === void 0) { spacing = 0; }
        if (padding === void 0) { padding = 0; }
        this.spacing = spacing;
        this.padding = padding;
        this.orientation = ListView_1.Orientation.Horizontal;
    }
    RowLayout.prototype.layout = function (itemSizes, viewportSize) {
        var _this = this;
        var y = this.spacing;
        var x = this.spacing;
        return itemSizes.map(function (size) {
            var imageHeight = viewportSize.height - (_this.spacing * 2) - (_this.padding * 2);
            var imageScale = imageHeight / size.height;
            var imageWidth = size.width * imageScale;
            var height = imageHeight + (_this.padding * 2);
            var width = imageWidth + (_this.padding * 2);
            var rect = { x: x, y: y, width: width, height: height };
            x += width + _this.spacing;
            return rect;
        });
    };
    return RowLayout;
}());
exports.RowLayout = RowLayout;
